// Mirror of backend/constants/creditPullStatus.js — there is no import path
// between backend/ and frontend/, so this is a deliberate copy and
// backend/test/creditPullStatusParity.test.js asserts the two agree.
//
// 🚨 WHY IT EXISTS: this file's two consumers used to compare the status string
// inline, and ReviewDocumentsCard.jsx did it TWO DIFFERENT WAYS — line 84 tested
// 'complete', line 159 tested 'completed'. Production holds both spellings, so
// line 159 was true for exactly the 2 drifted rows and false for the 12 it was
// written for. Nobody could see that by reading either line.
export const PULL_STATUS = {
  NOT_PULLED:  'not_pulled',
  PULLING:     'pulling',
  COMPLETE:    'complete',
  // ⚠️ DOORLY HOLDS A REPORT IT DID NOT PULL. Distinct from COMPLETE because the
  // difference is real — no inquiry was made by Doorly, and credit_pull_log must
  // not claim a pull that never happened — but hasReport() is true for BOTH,
  // because every reader asking "is there credit data" wants yes for both. That
  // is the whole reason this vocabulary landed before the value did: a reader
  // comparing strings would have said no.
  RECEIVED:    'received',
  // 🚨 THE BORROWER CONSENTED AND DOORLY OWES THEM A PULL. Added 2026-10-06
  // with the Xactus lock. pullAttempted() true so they are not asked again;
  // hasReport() false because there is nothing to read yet.
  AWAITING_DOORLY: 'awaiting_doorly',
  ERROR:       'error',
  PARSE_ERROR: 'parse_error',
};

const ALIASES = { completed: 'complete', success: 'complete' };

export function normalise(v) {
  if (v == null) return null;
  const s = String(v).trim().toLowerCase();
  if (!s) return null;
  if (Object.values(PULL_STATUS).includes(s)) return s;
  return ALIASES[s] || null;
}

/** Does Doorly hold usable credit data — the question every call site was asking. */
export function hasReport(v) { const s = normalise(v); return s === PULL_STATUS.COMPLETE || s === PULL_STATUS.RECEIVED; }

/** Has a pull been attempted at all. */
export function pullAttempted(v) { const s = normalise(v); return s !== null && s !== PULL_STATUS.NOT_PULLED; }

/** Did the last attempt fail in a way the borrower can retry. */
export function isError(v) { const s = normalise(v); return s === PULL_STATUS.ERROR || s === PULL_STATUS.PARSE_ERROR; }
